<template>
  <qx-card-form title="收入信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <!-- 收入单价 -->
      <section slot="priceUnit" slot-scope="prop">
        <el-input
          v-model="prop.form.priceUnit"
          class="inputBox"
          placeholder="请输入金额"
          @blur="calCostPrice"
        >
          <el-select
            class="inputAppendSelect"
            slot="suffix"
            v-model="otherFormData.priceEnum"
            :clear="true"
            @change="calCostPrice"
          >
            <!-- 单位 -->
            <el-option
              v-for="item in priceEnumOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-input>
      </section>
      <section slot="isUrgent" slot-scope="prop">
        <el-checkbox style="width: 240px;" label="是" name="type" v-model="prop.form.isUrgent" @change="isUrgentChange" />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import {isExist, isNegativeNumber} from '@qx/utils/index';
export default {
  data () {
    return {
      combineInfo: {},
      balanceData: {},
      priceEnumOptions: [],
      otherFormData: {
        priceEnum: '',
      },
      baseForm: {
        prePayEquivalenceCardTypeOptions: [],
        afterPayEquivalenceCardTypeOptions: [],
        inline: true,
        form: [
          {
            label: '加班车',
            value: 'isUrgent',
            default: false,
            slot: true,
          },
          {
            label: '预估收入',
            value: 'costPrice',
            type: 'input',
            placeholder: '0.00',
            readonly: true,
          },
          {
            label: '收入单价',
            value: 'priceUnit',
            slot: true,
          },
          {
            label: '预付现金',
            value: 'prePayCash',
            type: 'input',
            placeholder: '0.00',
            onBlur: () => {
              this.$emit('changePrePayCash', 'incomeForm');
            },
          },
          // {
          //   label: '等值卡额',
          //   value: 'prePayEquivalenceCardAmount',
          //   type: 'input',
          //   onBlur: () => {
          //     this.$emit('changePrePayEquivalenceCardAmount', 'incomeForm');
          //   },
          // },
          // {
          //   label: '等值卡',
          //   value: 'prePayEquivalenceCardType',
          //   type: 'select',
          //   default: '-1',
          //   onChange: (val) => {
          //     this.setFormAttrVal({
          //       form: this.baseForm,
          //       attr: 'readonly',
          //       value: val === '-1',
          //       names: ['prePayEquivalenceCardNumber'],
          //     });
          //   },
          // },
          // {
          //   label: '等值卡号码',
          //   value: 'prePayEquivalenceCardNumber',
          //   type: 'input',
          //   readonly: true,
          // },
          {
            label: '尾款现金',
            value: 'afterPayCash',
            type: 'input',
            onBlur: () => {
              this.$emit('changeAfterPayCash', 'incomeForm');
            },
          },
          // {
          //   label: '等值卡额',
          //   value: 'afterPayEquivalenceCardAmount',
          //   type: 'input',
          //   onBlur: () => {
          //     this.$emit('changeAfterPayEquivalenceCardAmount', 'incomeForm');
          //   },
          // },
          // {
          //   label: '等值卡',
          //   value: 'afterPayEquivalenceCardType',
          //   type: 'select',
          //   default: '-1',
          //   onChange: (val) => {
          //     this.setFormAttrVal({
          //       form: this.baseForm,
          //       attr: 'readonly',
          //       value: val === '-1',
          //       names: ['afterPayEquivalenceCardNumber'],
          //     });
          //   },
          // },
          // {
          //   label: '等值卡号码',
          //   value: 'afterPayEquivalenceCardNumber',
          //   type: 'input',
          //   readonly: true,
          // }
        ],
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (options) {
      this.priceEnumOptions = options[0];
      this.baseForm.prePayEquivalenceCardTypeOptions = options[1];
      this.baseForm.afterPayEquivalenceCardTypeOptions = options[1];
    },
    // 获取变更的信息
    setData (data = {}) {
      this.combineInfo = data;
      const info = {
        priceUnit: data.line.priceUnit,
        costPrice: data.line.estimateIncome ? (data.line.estimateIncome / 100.0).toFixed(2) : 0,
        prePayEquivalenceCardType: typeof data.prePayEquivalenceCardType !== 'number' ? '-1' : `${data.prePayEquivalenceCardType}`,
        afterPayEquivalenceCardType: typeof data.afterPayEquivalenceCardType !== 'number' ? '-1' : `${data.afterPayEquivalenceCardType}`,
      };

      let balanceType = data.line.payWay + '';
      if (!isExist(balanceType)) {
        balanceType = '-1';
      }
      this.balanceData.balanceType = balanceType;
      this.otherFormData.priceEnum = data.line.priceEnum;

      this.$refs.baseForm.setVal('form', info);
      this.$emit('calPreAndFinalFee', 1);
    },
    // 是否加班车，如果选择【是】，预计收入可以修改，否则禁止操作
    isUrgentChange (isUrgent) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'readonly',
        value: !isUrgent,
        names: ['costPrice'],
      });
    },
    // 计算单价
    calCostPrice () {
      const priceUnit = this.$refs.baseForm.getVal('priceUnit');
      this.$refs.baseForm.setVal('priceUnit', isNegativeNumber(priceUnit));
      this.$emit('calCostPrice', 'incomeForm');
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        let customerInfo = {};
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            if (name === 'isUrgent') {
              customerInfo['customerInfo.' + name] = Number(formData[name]);
            } else {
              customerInfo['customerInfo.' + name] = formData[name];
            }
          }
        }
        customerInfo['customerInfo.priceEnum'] = this.otherFormData.priceEnum;
        let priceEnumAndUnitName = '';
        let priceUnitName = '';
        for (let item of this.priceEnumOptions) {
          if (item.value === this.otherFormData.priceEnum) {
            priceUnitName = item.label;
          }
        }
        priceEnumAndUnitName = `${formData.priceUnit || ''}${priceUnitName}`;
        customerInfo['customerInfo.priceEnumAndUnitName'] = priceEnumAndUnitName;
        formData = customerInfo;
      }
      console.log(formData);
      return formData;
    },
    setDetailData (data) {
      if (data.orderScheduler) {
        data.isUrgent = data.orderScheduler.isUrgent;
      }

      if (data.orderFee) {
        data.costPrice = data.orderFee.costPrice / 100;
        data.priceUnit = data.orderFee.priceUnit;
        data.prePayCash = data.orderFee.prePayCash / 100;
        data.prePayEquivalenceCardAmount = data.orderFee.prePayEquivalenceCardAmount;
        data.prePayEquivalenceCardType = data.orderFee.prePayEquivalenceCardType;
        data.prePayEquivalenceCardNumber = data.orderFee.prePayEquivalenceCardNumber;
        data.afterPayCash = data.orderFee.afterPayCash / 100;
        data.afterPayEquivalenceCardAmount = data.orderFee.afterPayEquivalenceCardAmount;
        data.afterPayEquivalenceCardType = data.orderFee.afterPayEquivalenceCardType;
        data.afterPayEquivalenceCardNumber = data.orderFee.afterPayEquivalenceCardNumber;
        data.priceEnum = `${data.orderFee.priceEnum}`;
      }

      if (data.priceUnit === undefined || data.priceUnit === null) {
        data.priceUnit = '0';
      }
      if (data.priceEnum === undefined || data.priceEnum === null) {
        data.priceEnum = this.priceEnumOptions[0].value;
      }
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.setDetailData(data);
      this.$refs.baseForm.setVal(data);
      this.setFormVal(this.otherFormData, data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
